import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const mailCodeSavingsOfferComponent = {
  originalPayment: 'mail-code-savings-offer.originalPayment',
  originalPaymentLabel: 'mail-code-savings-offer.originalPaymentLabel',
  refinancePayment: 'mail-code-savings-offer.refinancePayment',
  refinancePaymentLabel: 'mail-code-savings-offer.refinancePaymentLabel',
  root: 'mail-code-savings-offer.root',
  savingsAmount: 'mail-code-savings-offer.savingsAmount',
  savingsAmountLabel: 'mail-code-savings-offer.savingsAmountLabel',
} as const satisfies ComponentLocatorMap;
